<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                            <i class="fa fa-chevron-circle-left"></i> {{$t('text.globals.back')}}
                        </a>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">

                        <h2 class="mb-3">
                            {{$t('text.documentAddVersion.newDocumentVersionUpload')}} <b>{{name}}</b>
                        </h2>

                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card mb-3 form-condensed">
                            <div class="card-body bg-light">

                                <loading :active.sync="isLoading"
                                         :can-cancel="false"
                                         :is-full-page="false"></loading>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="file">{{$t('text.documentAddVersion.fileToUpload')}}</label>


                                            <input type="file" class="form-control" id="file"
                                                   @change="getFile"
                                                   ref="myFile"
                                                   name="file"
                                            />

                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="mimetype">Mimetype</label>


                                            <input type="text" class="form-control" id="mimetype"
                                                   v-model="mimetype"
                                                   name="mimetype"
                                            />

                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-6 mt-2 mb-1">
                                        <hr/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <h4>{{$t('text.documentAddVersion.user')}}</h4>

                                        <div class="form-group">
                                            <label for="alfrescoUser">{{$t('text.documentAddVersion.alfrescoUser')}}</label>
                                            <input type="text" class="form-control" id="alfrescoUser"
                                                   aria-describedby="alfrescoPassword"
                                                   v-model="alfrescoUser"

                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="alfrescoPassword">{{$t('text.documentAddVersion.alfrescoPassword')}}</label>
                                            <input type="text" class="form-control" id="alfrescoPassword"
                                                   aria-describedby="alfrescoPassword"
                                                   v-model="alfrescoPassword"

                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="externalUserType">{{$t('text.documentAddVersion.externalUserType')}}</label>
                                            <v-select class="form-control"
                                                      :options="$t('text.documentAddVersion.externalUserTypeOptions')"
                                                      id="externalUserType"
                                                      v-model="externalUserType">
                                                <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="externalUserId">{{$t('text.documentAddVersion.externalUserId')}}</label>
                                            <input type="text" class="form-control" id="externalUserId"
                                                   aria-describedby="externalUserId"
                                                   v-model="externalUserId"

                                            />
                                        </div>


                                        <div class="form-group">
                                            <label for="externalUserCertId">{{$t('text.documentAddVersion.externalUserCertId')}}</label>
                                            <input type="text" class="form-control" id="externalUserCertId"
                                                   aria-describedby="externalUserCertId"
                                                   v-model="externalUserCertId"

                                            />
                                        </div>

                                    </div>
                                </div>


                                <div class="row mt-2">
                                    <div class="col-md-12 text-right">
                                        <a class="btn btn-primary text-white" @click="uploadFile()"><i
                                                class="fas fa-file-import"></i> {{$t('text.globals.upload')}}</a>
                                    </div>
                                </div>

                            </div>

                        </div>


                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <router-link :to="{name: 'DocumentDetails', params: {id: this.uuid}}" id="goToDocumentDetails"
                                     type="submit" class="btn btn-secondary float-left">
                            {{$t('text.documentAddVersion.backToDocument')}}
                        </router-link>
                    </div>
                </div>

            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import $ from 'jquery';
    import AudiLogExternalTable from "../components/AudiLogExternalTable";
    import jsonxml from 'jsontoxml';
    import convert from 'xml-js';

    export default {
        name: 'DocumentAddVersion',
        components: {
            Loading,
            vSelect
        },

        data() {
            return {
                uuid: this.$route.params.id,
                name: '',
                mimetype: null,
                alfrescoUser: null,
                alfrescoPassword: null,
                externalUserType: null,
                externalUserId: null,
                externalUserCertId: null,
                file: null,
                fileType: null,
                isLoading: false,
                allMetadataOptions: []
            };
        },

        computed: {},

        mounted() {

            const _this = this;

            let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1, p2]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
                _this.getNode();
            });

        },

        methods: {

            async getNode(nodeId) {
                const _this = this;

                _this.isLoading = true;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + _this.uuid)
                    .then((res) => {
                        console.log("res", res);
                        _this.name = res.data.entry.properties['cm:title'];
                        _this.mimetype = res.data.entry.content.mimeType;
                        _this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoading = false;
                    });


            },

            getFile() {
                const _this = this;

                _this.file = _this.$refs.myFile.files[0];
                console.log("this file: ", _this.file);
                _this.name = _this.file.name;
                _this.mimetype = _this.file.type;
                console.log(_this.file);
            },

            uploadFile() {
                const _this = this;
                console.log("TODO - UPLOAD");
                
                if(_this.mimetype === '') {
                    swal(
                        this.$t('text.globals.error'),
                        this.$t('text.documentAddVersion.mimetypeRequired'),
                        "error",
                        { dangerMode: true }
                    );
                    return;
                }

                _this.isLoading = true;

                let data = {
                    filename: _this.name,
                    mimetype: _this.mimetype,
                    alfrescoUser: _this.alfrescoUser,
                    alfrescoPassword: _this.alfrescoPassword,
                    externalUserType: _this.externalUserType,
                    externalUserId: _this.externalUserId,
                    externalUserCertId: _this.externalUserCertId
                };

                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("data", JSON.stringify(data));

            axios.post(config.demoVpisnik + this.uuid, formData)
            .then((res) => {

                _this.isLoading = false;

                Vue.$toast.open({
                    message: this.$t('text.documentAddVersion.documentVersionUploadSuccessToast'),
                    type: 'success',
                        position: 'top-right'
                    });

                })
                .catch((error) => {
                    console.error(error);

                    _this.isLoading = false;
                    console.log("Pri nalaganju nove različice dokumenta je prišlo do napake:", error);

                });

            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentAddVersion.vue